<script setup>
import {
    defineProps,
    onMounted,
    ref,
    defineExpose,
    // watch,
    nextTick,
    onUnmounted,
    inject,
    watch,
    toRefs,
    defineEmits
} from 'vue';
import i18n from "@/i18n"
import myDailog from '../common/myDailog.vue';
import { sankey1Chart, drawRadar } from "@/utils/chart.js"
import { useRoute } from 'vue-router';
import { getFileUrl } from "@/service"
import { get_dashboarddigital_passport_database_detail } from "@/service/apiList/dashboard"
// import { showMessage } from "@/utils/hooks/message"
import PreviewImg from "@/components/common/PreviewImg";
import moment from 'moment';
import { getLangValue, makeQrCode, getNewline } from "@/utils/common"; //获取后端语言
const props = defineProps({
    title: {
        type: String,
        required: true,
        default: '数字护照：质量'
    },
    title1: {
        type: String,
        required: true,
        default: getLangValue('dashboard.quality.titleText5_new')
    },
    title2: {
        type: String,
        required: true,
        default: getLangValue('dashboard.quality.special_functional_indicators')
    },
    sankey_v3_data: {
        type: Object,
        required: true,
        default: () => { }
    },
})
const emits = defineEmits(['showPlaceChart'])  // 展示产地组成结构
const showPreviewImg = ref(false)
const route = useRoute()
const myChartsRef = ref(null)
let resizemychart1Ob = null // mychart 振动 动态监听
const detailInfo = inject('detailInfo')
const srcList = ref([])
const order_by = ref('desc')
const indicator_standard_list = ref([]) //特殊指标list
const imageList = ref([])
const visible = ref(false)
const nodeDataList = ref([]) // 展示桑基图产品对应的pid
const showInstand = ref(true)
const ragarOption = ref({}) // 当前显示radar图
const { sankey_v3_data } = toRefs(props)
const showPlaceChart = ref(true)
const fieldsList = ref([
    {
        name: getLangValue('product-management.name'),
        key: 'productsname'
    },
    {
        name: 'HS Code',
        key: 'title'
    },
    {
        name: getLangValue('dashboard.hScodedescription'),
        key: 'description'
    },

    {
        name: getLangValue('dashboard.supplier'),
        key: 'company_name'
    },
    {
        name: getLangValue('product-management', "code_oid"),
        key: 'oid'
    },
    {
        name:getLangValue('product-management', "code_pid_gtin"),
        key: 'pid'
    },

    {
        name: getLangValue('dashboard.batchtotalquantity'),
        key: 'batch_size'
    },
    {
        name: getLangValue('dashboard.listingTime'),
        key: 'release_time',
        showChart: true
    },
    {
        name: getLangValue('product-template.origin'),
        key: 'place_of_origin',
        showChart: true
    },
    {
        name: getLangValue('product-template.targetmarket'),
        key: 'targetmarket',
        showChart: true
    },
    {
        name: getLangValue('product-template.size'),
        key: 'size',
        showChart: true
    },
    {
        name: getLangValue('product-template.color'),
        key: 'color',
        showChart: true
    },
])
const loadingRadar =inject('loadingRadar') // 雷达图加载效果
const loadingSankey = inject('loadingSankey') // 桑基图加载效果
//methods
const qrcode = async () => {
    if (!detailInfo.value.pid && !detailInfo.value.organization.oid) return
    // 根据详细信息
    // 根据详细信息
    const reps = await makeQrCode({ type: 2, id: route.query.id })
    if (reps) {
        imageList.value.push(reps);
    }
    // 组织机构信息
    const reps1 = await makeQrCode({ type: 1, id: detailInfo.value.organization?.id })
    if (reps) {
        imageList.value.push(reps1);
    }
}

const showChart1 = () => {
    // 展示全部的追溯图
    emits('showPlaceChart');
}
// const showChart = async (type = 'normal') => {
//     //展示图表信息
//     // 展示图表
//     let params = {
//         table_name: detailInfo.value.organization.table_name,
//         database_id: '672c852c5f3422276241e853',
//         category_id: 1, // 可追溯性
//     }
//     const reps = await sankey_v3(params)
//     if (reps.code == 1) {
//         showMessage('danger', reps.message)
//         return
//     }
//     if (reps.payload.nodes.length && reps.payload.links.length) {
//         visible.value = type == 'normal' ? true : false
//         nextTick(() => {
//             makeCharts(reps.payload, type)
//         })
//     } else {
//         showMessage('info', getLangValue('base.no_data'))
//     }
// }
const makeCharts = (data, type) => {
    // let attributes = {}
    // // 属性信息
    // for (const item in data.nodes) {
    //     attributes[data.nodes[item].name] = data.databases[item].pid
    // }
    let options = {
        chartDom: type == 'normal' ? myChartsRef.value : document.getElementById('small-chart'),
        // data: reps.payload,
        data: data,
    };
    sankey1Chart(options, false, type);
    // 展示对应的pid信息
    nodeDataList.value = data.nodes
}



const getData = async () => {
    // 通过id查询详情
    const resp = await get_dashboarddigital_passport_database_detail({category_id: 1,  id:route.query.id })
    if (resp.code == 0) {
        // 缺少数据 整合table的数据
        detailInfo.value = { ...resp.payload, }
        imageList.value = []
        // 获取图片
        if (detailInfo.value['product_info']) {
            let arr = detailInfo.value['product_info'].children.filter(item => item.key == 'product_info_product_picture')
            if (arr.length > 0 && arr[0].value.length) {
                let imgStr = arr[0].value[0]
                if (imgStr)
                    getFileUrl({ attachments: imgStr }).then(resp => {
                        if (resp) {
                            imageList.value.push(resp.payload[0].url)
                            srcList.value = resp.payload
                            qrcode();
                        }
                    })
            } else {
                imageList.value = [""]
                qrcode();
            }
        } else {
            imageList.value = [""]
            qrcode();
        }
        // // 切换缩略雷达图
        // showChart('small')
    }
}

const showPicture = () => {
    showPreviewImg.value = true
}

const drawRadarChart = (data) => {
    // console.log(data);
    /**雷达图 指标 */
    if (data.length == 0) return
    data.sort((a, b) => {
        // 将 name 为 "综合" 的对象排到最前面
        if (a.name === "综合" && b.name !== "综合") return -1;
        if (a.name !== "综合" && b.name === "综合") return 1;
        return 0; // 其他元素保持原始顺序
    });
    // 指标list
    let indicatorList = data.map(item => {
        return {
            name: i18n.global.locale == 'en' ? getNewline(item.name_en, 10) : getNewline(item.name, 10),
            name1: i18n.global.locale == 'en' ? item.name_en : item.name,
            max: 1,
        }
    })
    // 值
    let valueList = data.map(item => item.value)
    // 均值
    let avgValueList = data.map(item => item.avg_value)
    // console.log(valueList);
    let option = {
        tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: function (params) {
                // let str = ``;
               let str = ` <div style='color: ${params.color};font-weight: bold'>${params.name}</div>`;
                for (const item in params.value) {
                    str += `<div>
                        <div style='min-width:100px; text-align:left; display:inline-block'>
                            ${indicatorList[item].name}
                        </div>
                            :
                         <div style='min-width:100px; text-align:left; display:inline-block'>${params.value[item]==null? '-': params.value[item]}</div>
                    </div>`
                }
                return str
            }
        },
        grid: {
            left: -20,
            right: 0,
            bottom: 0,
            top: '3%',
            containLabel: true
        },
        radar: {
            indicator: indicatorList,
            radius: 60,
            // 设置角标颜色和样式
            axisName: {
                color: '#000', // 设置角标颜色
                fontSize: 13, // 字体大小
            },
            splitLine: { //里面四个圈线条样式
                lineStyle: {
                    color: [
                        'rgba(169,169,169, 1)',
                        'rgba(232, 236,244, 1)',
                        'rgba(232, 236,244, 1)',
                        'rgba(232, 236,244, 1)',
                        'rgba(232, 236,244, 1)',
                    ],//分别对应四个第一个对应最里面的圈
                    width: 2,
                }
            },
            axisLine: {
                lineStyle: {
                    color: "rgba(169,169,169, 1)",
                    width: 2, // 轴线宽度
                }
            },
            axisLabel: {
                show: true,
                formatter: function (value, index) {
                    // 只在最后一个角显示最大值
                    if (index === 5) {
                        return value;
                    } else {
                        return '';
                    }
                }
            }
        },
        series:
            [
                {
                    type: 'radar',
                    tooltip: {
                        trigger: 'item',
                    },
                    radarIndex: 0,
                    // areaStyle: {},
                    data: [
                        {
                            name: getLangValue('dashboard.value'),
                            value: valueList,
                            lineStyle: {
                                color: '#299CDB',
                            },

                        },
                        {
                            name: getLangValue('dashboard.avg_value'),
                            value: avgValueList,
                            lineStyle: {
                                color: '#7F7F7F',
                            },
                            itemStyle: {
                                color: '#7F7F7F'
                            },
                        },
                    ]
                },
            ]
    };
    // console.log(option);
    ragarOption.value = { option, indicatorList }
    // visible.value = true
    nextTick(() => {
        let dom = document.getElementById('index_standard_chart')
        const mychartRarda = drawRadar(dom, option,)
        // 监听容器宽度变化
        resizemychart1Ob = new ResizeObserver(() => mychartRarda.resize());
        resizemychart1Ob.observe(dom);
    })

}

const showBigChart = () => {
    //展示完整雷达图
    visible.value = true
    nextTick(() => {
        let { option, indicatorList } = ragarOption.value
        option.radar.radius = 150;
        option.radar.indicator = indicatorList.map(item => {
            return {
                name: item.name1,
                max: 1,
            }
        });
        drawRadar(myChartsRef.value, option,)
    })

}

const getDetailInfo = (key) => {
    // 获取尺寸颜色
    if (detailInfo.value.product_info) {
        let ColorInfo = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_color')
        if (ColorInfo.length > 0 && key == 'color') {
            return ColorInfo[0].value
        }
        let sizeInfo = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_size')
        if (sizeInfo.length > 0 && key == 'size') {
            return sizeInfo[0].value
        }
        let batchsize = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_batch_size')
        if (batchsize.length > 0 && key == 'batch_size') {
            return batchsize[0].value
        }
        let productsname = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_product_name')
        if (productsname.length > 0 && key == 'productsname') {
            return productsname[0].value
        }
    }
    return ''
}

const getTargetmarket = () => {
    // 获取目的市场
    if (detailInfo.value.template_info && detailInfo.value.template_info.children && detailInfo.value.template_info.children.length) {
        let obj = detailInfo.value.template_info.children.find(item => item.key == 'template_info_destination_market')
        return i18n.global.locale == 'en' ? obj.value_en : obj.value
    }
    return ''
}

const getdescprtion = () => {
    // 获取描述
    if (detailInfo.value.template_info && detailInfo.value.template_info.children && detailInfo.value.template_info.children.length) {
        let obj = detailInfo.value.template_info.children.find(item => item.key == 'template_info_description')
        return i18n.global.locale == 'en' ? obj.value_en : obj.value
    }
    return ''
}


onMounted(() => {
    // qrcode();
    // console.log(productList.value);
    getData();
    // drawRadarChart()
})

// 销毁
onUnmounted(() => {
    if (resizemychart1Ob) {
        console.log('销毁振动..');
        resizemychart1Ob.disconnect();
    }
})

watch(sankey_v3_data, (val) => {
    if (val.nodes) {
        makeCharts(val, 'small')
    }

})


defineExpose({
    indicator_standard_list,
    drawRadarChart,
    order_by,
    showPlaceChart
})
</script>
<template>
    <div class="card card1 px-3 py-2" style="width: 100%;border-radius: 0.55rem;">
        <div class="my-card-header">{{ props.title }}</div>
        <div class="my-card-content ">
            <div class="my-scroll-bar" style="flex: 1; max-height: calc(100% - 300px); display: flex;
             flex-direction: column;
             justify-content: space-between;
             overflow-y: auto;
             position: relative;
             ">
                <div>
                    <div class="mt-2" style="text-align: center;border: 1px dashed white; height: 1px;"></div>
                    <!-- 图片二维码信息 -->
                    <div class="d-flex justify-content-between my-1" v-if="imageList.length">
                        <div class="d-flex justify-content-center "
                            style="background-color: white;width: 140px; height: 140px; border-radius: 4px;">
                            <img :src="imageList[0]" style="height: 140px; width: 140px;" class="cursor-pointer"
                                @click="showPicture">
                        </div>
                        <div style="height: 150px;">
                            <img :src="imageList[1]" style="height: 140px; width: 140px;">
                            <div style="text-align: center;font-size: 14px;color: #212529;">{{getLangValue('product-management', "code_pid_gtin")}}</div>
                        </div>
                        <div style="height: 150px;">
                            <img :src="imageList[2]" style="height: 140px; width: 140px;">
                            <div style="text-align: center;font-size: 14px;color: #212529;">{{getLangValue('product-management', "code_oid")}}</div>
                        </div>
                    </div>
                </div>
                <!-- 信息list -->
                <div class="fieldslist"
                    style="flex: 1; display: flex; justify-content: space-around; flex-direction: column;">
                    <div class="my-1" v-for="(item, k) in fieldsList" :key="k" style="font-size: 14px; color: #212529;"
                        :style="k == fieldsList.length - 1 ? { 'font-size': '14px', 'color': '#212529', 'position': 'relative' } : { 'font-size': '14px', 'color': '#212529', }">
                        <span :class="k > 7 ? 'chartField' : ''">
                            {{ item.name }} :
                            <template v-if="item.key == 'title'">
                                <span
                                    v-if="detailInfo.production_line && detailInfo.production_line.database_template && detailInfo.production_line.database_template.hscode">{{
                                        detailInfo.production_line.database_template.hscode[item.key] }}</span>
                            </template>
                            <template v-else-if="item.key == 'description'">
                                <span>
                                    {{ getdescprtion() || '-' }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'oid' || item.key == 'company_name'">
                                <span v-if="detailInfo.organization">{{ detailInfo.organization[item.key] }}</span>
                            </template>
                            <template v-else-if="item.key == 'pid'">
                                <span>{{ item.key == 'pid' ? `FBD` + detailInfo[item.key] : detailInfo[item.key]
                                    }}</span>
                            </template>

                            <template v-else-if="item.key == 'place_of_origin'">
                                <span v-if="detailInfo.production_line && detailInfo.production_line.place_of_origin" :title="detailInfo.production_line.place_of_origin.name">{{
                                    detailInfo.production_line.place_of_origin.name }}</span>
                            </template>
                            <template v-else-if="item.key == 'productsname'">
                                <span>
                                    {{ getDetailInfo(item.key) }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'batch_size'">
                                <span>
                                    {{ getDetailInfo(item.key) }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'targetmarket'">
                                <span :title="getTargetmarket()">
                                    {{ getTargetmarket() }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'release_time'">
                                <span>
                                    {{ detailInfo.release_time &&
                                        moment(detailInfo.release_time).format('YYYY-MM-DD') || '-' }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'size' || item.key == 'color'">
                                <span>
                                    {{ getDetailInfo(item.key) }}
                                </span>
                            </template>
                            <span v-else :title="detailInfo[item.key]">{{ detailInfo[item.key] }}</span>

                        </span>
                        <div v-if="k == fieldsList.length - 1"
                            style="position: absolute; bottom: 0; right: 0; width: 300px;">
                            <div v-loading="loadingSankey">
                                <div style="height: 100px; width: 90%; padding-left: 20px;" id="small-chart"
                                    @click="showChart1()"></div>
                                <div style="text-align: center;">
                                    <a @click="showChart1()" :class="showPlaceChart ? 'active' : ''"
                                        style="color: #0AB39C; cursor: pointer;">
                                        {{ getLangValue('dashboard.traceability.traceability_map') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 300px;">
                <div class="mt-2" style="text-align: center;border: 1px dashed #212529; height: 1px;"></div>
                <!-- 质量评级 -->
                <div class="rank mt-1" style="height: calc(100% - 1rem);">
                    <div class="d-flex justify-content-between h-100">
                        <!-- 2024-10-9新增图表 -->
                        <div style="min-width: 300px; flex: 6;height: 100%;position: relative;">
                            <el-popover placement="top-start" trigger="hover" width="200">
                                <template #reference>
                                    <i class=" ri-error-warning-fill"
                                        style="position: absolute; top: 30px;left:-10px;color:#5a6fc0; font-size: 20px;"></i>
                                </template>
                                <template #default>
                                    <div>
                                        <div id="rankInfo" class="display-inline">
                                            <div style="text-align: left;"> 0:
                                                {{ getLangValue('dashboard.traceability.titleText6') }}
                                            </div>
                                            <div style="text-align: left;"> 1:
                                                {{ getLangValue('dashboard.traceability.titleText7') }}
                                            </div>
                                        </div>

                                    </div>
                                </template>
                            </el-popover>
                            <div
                                style="height: 20px;font-size: 0.7vw; font-weight: 700; color: #212529; text-align: center">
                                {{ props.title1 }}</div>
                            <div style="width: 100%; height: 210px; position: absolute; bottom: 10px;"
                                id="index_standard_chart" @click="showBigChart" v-loading="loadingRadar">
                            </div>
                        </div>
                        <div v-show="showInstand" style=" height: 100%;  min-width: 40px; max-width: 200px; flex: 4;">
                            <div style=" height: 100%;  width: 100%;">
                                <div @click="showInstand = false" class="cursor-pointer"
                                    :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                                    style="min-height: 20px;font-size: 0.7vw; font-weight: 700; color: #212529;text-align: center; word-break: break-all;">
                                    {{ props.title2 }}</div>
                                <div style="height: calc(100% - 30px); text-align: left; overflow-y: auto; overflow-x: hidden; border-left: 1px dashed #212529;"
                                    class="d-flex flex-column  flex-1 ps-1 my-scroll-bar">
                                    <div class="my-1 d-flex align-items-center "
                                        v-for="(item, k) in indicator_standard_list" :key="k"
                                        style="text-align: left; flex-wrap: wrap; ">
                                        <!-- {{ getLangValue("dashboard.quality.special_indicators") }}：1度1111141414 -->
                                        <div style="text-align: left;">{{ i18n.global.locale =='en'? item.index_standard?.name_en: item.index_standard?.name }}:</div>
                                        <div style="text-align: left;">
                                            {{ item.value }}{{ item.index_standard && item.index_standard.unit ?
                                                `(${ i18n.global.locale =='en'? item.index_standard?.unit_en: item.index_standard.unit})` : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 图标 -->
                        <i class="ri-arrow-left-s-line mx-2 cursor-pointer" style="font-size: 24px;"
                            v-show="!showInstand" @click="showInstand = true"></i>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- 弹框展示图表 -->
    <myDailog v-if="visible" v-model:visible="visible" :title="props.title1" :width="800">
        <div style="width: 100%; height: 500px;" ref="myChartsRef"></div>
        <!-- <div class="d-flex mt-2 justify-content-between flex-wrap">
            <div style="width: 30%; font-size: 12px; text-align: left;" v-for="(item, key) in nodeDataList" :key="key"
                class="m-2">
                <b>{{ item.name }}</b>:{{ item.pid }}
                <div v-if="item.value != null && props.category == 5"><b>{{ getLangValue('dashboard.total_pef') }}</b>:{{
                    item.value
                    }}</div>
                <div v-if="item.value != null && props.category == 6"><b>{{ getLangValue('dashboard.total_esg') }}</b>:{{
                    item.value
                    }}</div>
                <div v-if="item.value != null && props.category == 4"><b>{{ getLangValue('dashboard.total_circularity') }}</b>:{{
                    item.value }}</div>
            </div>
        </div> -->
    </myDailog>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :srcList="srcList" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
</template>
<style scoped lang="scss">
// .card {
//     background-color: #495057;
//     border: 1px solid #D9D9D980;
//     height: calc(100% - 1.3rem);

//     .my-card-header {
//         color: white;
//         font-size: 16px;
//         font-weight: 700;
//     }

//     .my-card-content {
//         height: calc(100% - 24px);
//         display: flex;
//         flex-direction: column;

//         .hscode {
//             color: #9599AD;
//             word-break: break-all;

//             .active {
//                 color: white !important;
//             }
//         }

//         .search {
//             height: 38px;

//             :deep(.el-select__selected-item) {
//                 color: white;
//             }

//             :deep(.el-select__wrapper) {
//                 background-color: #4a5056;
//                 height: 100%;
//             }

//             :deep(.el-select__placeholder.is-transparent) {
//                 color: #889AA5 !important;
//             }

//             :deep(.el-input--suffix) {
//                 width: 110px;
//                 height: 100%;
//             }

//             :deep(.el-input__wrapper) {
//                 background-color: #4a5056;
//             }

//             :deep(.el-input__inner) {
//                 color: white;
//             }

//             .form-control {
//                 background-color: #4a5056;
//                 color: white;
//             }
//         }
//     }
// }

.card1 {
    // background-color: #495057;
    border: 1px solid #D9D9D980;
    // height: calc(100% - 1.3rem);

    .my-card-header {
        color: #212529;
        font-size: 16px;
        font-weight: 700;
    }

    .my-card-content {
        height: calc(100% - 24px);
        display: flex;
        flex-direction: column;

        .hscode {
            color: #9599AD;
            word-break: break-all;

            .active {
                color: white !important;
            }
        }

        .search {
            height: 38px;

            :deep(.el-select__selected-item) {
                color: #212529;
            }

            :deep(.el-select__wrapper) {
                // background-color: #4a5056;
                height: 100%;
            }

            :deep(.el-select__placeholder.is-transparent) {
                color: #889AA5 !important;
            }

            :deep(.el-cascader .el-input--suffix) {
                width: 100% !important;
            }

            :deep(.el-input--suffix) {
                width: 110px;
                height: 100%;
            }

            // :deep(.el-input__wrapper) {
            //     // background-color: #4a5056;
            // }

            :deep(.el-input__inner) {
                color: #212529;
            }

            .form-control {
                // background-color: #4a5056;
                color: #212529;
            }
        }

        .rank {
            .ball {
                background-color: #0AB39C;
                min-width: 15px !important;
                height: 15px;
                border-radius: 15px;
            }
        }
    }
}

.active {
    color: #889AA5 !important;
    text-decoration: underline !important;
}

.chartField {
    width: 160px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
<style>
.active.el-dropdown-menu__item {
    color: #409eff;
}

.el-tooltip__trigger:focus {
    outline: none;
}
</style>